import { asyncAction } from '../common';
import { dashboardEventsFilterActions } from '../../constants/filter';
import { errorHandlerUnitsQueries } from './dashboards';
import executeDashboardEvents from '../../api/eventsDashboard';

export const executeDashboardEventQueries = (unit, executeId) =>
  asyncAction(
    'EXECUTE_DASHBOARD_EVENT_QUERIES',
    executeDashboardEvents(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );

export const executeDashboardEventQueriesStart = (unit) => ({
  type: 'EXECUTE_DASHBOARD_EVENT_QUERIES_START',
  unit,
});

export const changeEventView = (unitId, view) => ({
  type: 'DASHBOARD_CHANGE_EVENT_VIEW',
  view,
  unitId,
});

export const setEventColumnChartSorting = (unitId, sorting) => ({
  type: 'DASHBOARD_CHANGE_EVENTS_COLUMN_CHART_SORTING',
  unitId,
  sorting,
});

export const createInitialEvent = () => ({
  type: 'CREATE_INITIAL_EVENT',
});

export const addEvent = (unitId) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_ADD_EVENT',
  unitId,
});

export const duplicateEvent = (unitId, id) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_DUPLICATE_EVENT',
  unitId,
  id,
});

export const removeComposeEvent = (unitId, id) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_REMOVE_EVENT',
  unitId,
  id,
});

export const setName = (unitId, id, name, eventMetainf) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_NAME',
  unitId,
  id,
  name,
  eventMetainf,
});

export const setGroupColumn = (unitId, groupColumn) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_SET_GROUP_COLUMN',
  unitId,
  groupColumn,
});

export const setAggregationType = (unitId, id, aggregationType) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_AGGREGATION_TYPE',
  unitId,
  id,
  aggregationType,
});

export const setEventAggregationColumn = (unitId, id, aggregationColumn) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_AGGREGATION_COLUMN',
  unitId,
  id,
  aggregationColumn,
});

export const setSplitColumn = (unitId, id, splitColumn) => ({
  type: 'DASHBOARD_EVENTS_COMPOSE_SET_EVENT_SPLIT_COLUMN',
  unitId,
  id,
  splitColumn,
});

export const addFilterClause = (unitId, eventId) => ({
  type: dashboardEventsFilterActions.ADD_FILTER_CLAUSE,
  unitId,
  eventId,
});

export const removeFilterClause = (unitId, eventId, clauseId) => ({
  type: dashboardEventsFilterActions.REMOVE_FILTER_CLAUSE,
  unitId,
  eventId,
  id: clauseId,
});

export const setClausesConcatOperator = (unitId, eventId, value) => ({
  type: dashboardEventsFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  unitId,
  eventId,
  value,
});

export const setFilterClauseField = (unitId, eventId, clauseId, field, fieldType) => ({
  type: dashboardEventsFilterActions.SET_FILTER_CLAUSE_FIELD,
  unitId,
  eventId,
  id: clauseId,
  field,
  fieldType,
});

export const setFilterClauseValue = (unitId, eventId, clauseId, value) => ({
  type: dashboardEventsFilterActions.SET_FILTER_CLAUSE_VALUE,
  unitId,
  eventId,
  id: clauseId,
  value,
});

export const setFilterVisibility = (unitId, eventId, value) => ({
  type: dashboardEventsFilterActions.SET_FILTER_VISIBILITY,
  unitId,
  eventId,
  value,
});

export const removeFilter = (unitId, eventId) => ({
  type: dashboardEventsFilterActions.REMOVE_FILTER,
  unitId,
  eventId,
});

export const copyFilter = (unitId, eventId, clauses) => ({
  type: dashboardEventsFilterActions.COPY_FILTER,
  unitId,
  eventId,
  clauses,
});

export const setFilterClauseOperator = (unitId, eventId, clauseId, value, resetClauseValue) => ({
  type: dashboardEventsFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  unitId,
  eventId,
  id: clauseId,
  value,
  resetClauseValue,
});

export const setOthersFilter = (unitId, eventId, clauseId) => ({
  type: 'DASHBOARD_SET_OTHERS_FILTER',
  unitId,
  eventId,
  clauseId,
});

export const toggleCalcTotal = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_EVENTS_CALC_TOTAL',
  unitId,
});

export const toggleTrendLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_EVENTS_TREND_LINE',
  unitId,
});

export const toggleAverageLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_EVENTS_AVERAGE_LINE',
  unitId,
});

export const toggleMedianLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_EVENTS_MEDIAN_LINE',
  unitId,
});

export const toggleAdaptive = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_EVENTS_ADAPTIVE',
  unitId,
});

export const toggleCumulative = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_EVENTS_CUMULATIVE',
  unitId,
});

export const changeVisibleFormula = (unitId) => ({
  type: 'DASHBOARD_EVENT_CHANGE_VISIBLE_FORMULA',
  unitId,
});

export const enterFormula = (unitId, formula) => ({
  type: 'DASHBOARD_EVENT_ENTER_FORMULA',
  unitId,
  enteredFormula: formula,
});

export const enterLegendName = (unitId, name) => ({
  type: 'DASHBOARD_EVENT_ENTER_LEGEND_NAME',
  unitId,
  name,
});

export const changeFormulaOnly = (unitId) => ({
  type: 'DASHBOARD_EVENT_FORMULA_ONLY',
  unitId,
});

export const setEventExposeError = (unitId, error, id) => ({
  type: 'DASHBOARD_SET_EVENT_EXPOSURE_ERROR',
  unitId,
  error,
  id,
});

export const addPeriod = (unitId, id) => ({
  type: 'DASHBOARD_ADD_PERIOD',
  unitId,
  eventId: id,
});

export const deletePeriod = (unitId, id, index) => ({
  type: 'DASHBOARD_DELETE_PERIOD',
  unitId,
  eventId: id,
  index,
});

export const setPeriod = (unitId, id, index, from, to) => ({
  type: 'DASHBOARD_SET_PERIOD',
  unitId,
  eventId: id,
  index,
  from,
  to,
});

export const setShowPeriods = (unitId, id, value) => ({
  type: 'DASHBOARD_SET_SHOW_PERIODS',
  unitId,
  eventId: id,
  value,
});
